import { default as SpecialGiveAwayApp } from "./components/Main";

export default SpecialGiveAwayApp;
